import {
  TRANSFER_ORDER_WORKSPACE_QUEUES,
  type TransferOrderWorkspaceQueue,
  type TransferOrderWorkspaceQueueDefinition,
} from '../transfer-order-workspace-queues.js';

export function transferOrderQueueDefinition(
  queue: TransferOrderWorkspaceQueue,
): TransferOrderWorkspaceQueueDefinition {
  return TRANSFER_ORDER_WORKSPACE_QUEUES.find((item) => item.id === queue)!;
}
